import React, { useState, useEffect } from "react";
import "./ReportStatsCard.css";

const LoadingAnimation = () => <div className="loader"></div>;

const ReportStatsCard = ({ value, label, hint, isLoading, isError }) => {
  const [displayValue, setDisplayValue] = useState(0);

  useEffect(() => {
    if (isLoading || isError || value === 0) {
      setDisplayValue(0);
      return;
    }

    let currentValue = 0;
    const target = value;
    const increment = Math.ceil(target / 50);
    const duration = 1500; // 1.5s animation duration
    const step = duration / (target / increment);

    const interval = setInterval(() => {
      currentValue += increment;
      if (currentValue >= target) {
        setDisplayValue(target);
        clearInterval(interval);
      } else {
        setDisplayValue(currentValue);
      }
    }, step);

    return () => clearInterval(interval);
  }, [value, isLoading, isError]);

  return (
    <div className="reportCard">
      <div className={`reportCardValue ${isLoading ? "loading" : ""}`}>
        {isLoading ? <LoadingAnimation /> : isError ? "N/A" : displayValue.toLocaleString("uk-UA")}
      </div>
      <div className="reportCardLabel">{label}</div>
      <div className="reportCardHint">{hint}</div>
    </div>
  );
};

export default ReportStatsCard;
